@use '../styles/tokens' as *;

$trial-fill: #d5e7c0;
$trial-text: #3d7800;

.product {
  @include text-body-2;
  font-weight: 600;
  color: $blue-gray-1;
}

.trialBox {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 12px 15px;
  border-radius: 8px;
  background: $trial-fill;
}

.trialRow {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.trialPeriod {
  @include text-11;
  font-weight: 600;
  color: $trial-text;
}

.trialDue {
  @include text-13;
  color: $trial-text;
}

.trialPrice {
  @include text-body-2;
  color: $trial-text;
  white-space: nowrap;
}

.trialTaxes {
  @include text-11;
  color: $trial-text;
  white-space: nowrap;
}

.payNow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.payNowLabel {
  color: $black;
}

.payNowValue {
  @include text-heading-4;
  color: $black;
  white-space: nowrap;
}

.terms {
  display: flex;
  flex-direction: column;
  @include text-11;
  color: $blue-gray-4-5;
}

.termsTitle {
  font-weight: 600;
  color: $blue-gray-2;
}
